var React = require('react');

function ETL (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.3523 12.3727C20.2835 9.24723 17.3209 7 13.8333 7C9.44574 7 5.88889 10.5568 5.88889 14.9444C5.88889 15.1895 5.89998 15.4319 5.92169 15.6712C3.11596 16.2247 1 18.6986 1 21.6667C1 25.0417 3.73604 27.7778 7.11111 27.7778H27.8889C31.264 27.7778 34 25.0417 34 21.6667C34 18.6091 31.7545 16.076 28.8227 15.6264C28.088 13.4533 26.0323 11.8889 23.6111 11.8889C22.8061 11.8889 22.0414 12.0619 21.3523 12.3727Z","fill":"#5B59FB","key":0}),React.createElement("path",{"d":"M13.9121 20.9189H11.0996V22.8232H14.4004V24H9.63477V16.8906H14.3906V18.0771H11.0996V19.7715H13.9121V20.9189ZM20.709 18.0771H18.5312V24H17.0664V18.0771H14.918V16.8906H20.709V18.0771ZM23.0137 22.8232H26.124V24H21.5488V16.8906H23.0137V22.8232Z","fill":"white","key":1})]);
}

ETL.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = ETL;

ETL.default = ETL;
